module.exports = __webpack_public_path__ + "static/media/marketing_creatives.mobile.6eba00fb.svg";